// Shared "invite a friend" behavior. Sign-up is self-service, so an invite is just the
// app's URL plus a short pitch: no backend or email send is needed. Uses the native share
// sheet when available (mobile), otherwise copies the message to the clipboard and briefly
// confirms. The same hook powers the signup intro and the in-app invite card.

import { useState } from "react";

export const INVITE_PITCH =
  "Watch your brokerage margin and get alerted before a margin call.";

const DEFAULT_LABEL = "Invite a friend";
const COPIED_LABEL = "Invite copied to clipboard";

export function useInviteShare() {
  const [label, setLabel] = useState(DEFAULT_LABEL);

  const share = async () => {
    const url = window.location.origin;
    const message = `Try smart-margin: ${INVITE_PITCH} ${url}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: "smart-margin", text: INVITE_PITCH, url });
        return;
      }
      await navigator.clipboard.writeText(message);
      setLabel(COPIED_LABEL);
      setTimeout(() => setLabel(DEFAULT_LABEL), 2500);
    } catch {
      // The user dismissed the share sheet, or the clipboard was blocked. Leave the label.
    }
  };

  return { share, label };
}
